import React from 'react';
import { Field } from 'react-final-form';

export const Error = ({ name }) => (
  <Field
    name={name}
    subscribe={{ touched: true, error: true }}
    render={({ meta: { touched, error } }) =>
      touched && error ? <span style={{color: "#800", fontWeight: "bold", marginLeft: "10px", fontSize: "16px"}}>{error}</span> : null
    }
  />
);
